import React from "react";
import { Link } from "react-router-dom";
import Breadcrumbs from "../../Breadcrumbs/Breadcrumbs.js";
import Accordion from "../../Accordion/Accordion.js";
import useSEO from "../../hooks/useSEO.js";
import seoConfig from "../../hooks/seoConfig.js";

import data from "../../Data/specialists/specialistsData.json";
import list from "../../Data/specialists/specialistsDataList.json";

export default function Specialists() {
  useSEO(seoConfig.specialists);

  return (
    <section className="contacts education">
      <Breadcrumbs />
      <h1 className="contacts__title history__title licenses__title">
        Специалисты
      </h1>

      <div className="staff-list">
        {data.map((person) => (
          <div className="staff-card" key={person.id}>
            <div className="staff-card__photo">
              <img src={person.photo} alt={person.name} />
            </div>
            <div className="staff-card__info">
              <h2>{person.name}</h2>
              <p>
                {person.position}
                {person.abbreviated}
              </p>
              <Link
                to={`/patients/specialists/${person.slug}`}
                className="staff-card__link"
              >
                Подробнее →
              </Link>
            </div>
          </div>
        ))}
      </div>

      <Accordion data={list} />
    </section>
  );
}
